import { render } from "./ProjectHeader.vue?vue&type=template&id=317bdc64&scoped=true"
import script from "./ProjectHeader.vue?vue&type=script&lang=js"
export * from "./ProjectHeader.vue?vue&type=script&lang=js"

import "./ProjectHeader.vue?vue&type=style&index=0&id=317bdc64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317bdc64"],['__file',"src/components/generic/ProjectHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "317bdc64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('317bdc64', __exports__)) {
    api.reload('317bdc64', __exports__)
  }
  
  module.hot.accept("./ProjectHeader.vue?vue&type=template&id=317bdc64&scoped=true", () => {
    api.rerender('317bdc64', render)
  })

}


export default __exports__